import { Slinky } from './slinky.js';
// import init_submenu from './menu_dropdown.js';
import toggle from './menu_toggle.js';
import formChangeHandler from './form.js';
import init_favorites from './favorites.js';
import tingle from 'tingle.js';
import InfiniteScroll from 'infinite-scroll';
import { getParentsUntil } from './utilities.js';
import ScrollMagic from 'scrollmagic';
const axios = require('axios');
const API_URL = process.env.MIX_ORDERS_API_URL;
import Cleave from 'cleave.js';

//initialize mobile menu toggle
const toggleButton = document.querySelector(".toggle");
const myFunction = function() {
    toggle( document.querySelector('#mobile-menu') );
};
toggleButton.addEventListener('click', myFunction, false);

//initialize tablet and desktop submenus
//init_submenu();

//animations
window.onbeforeunload = function(){
    document.querySelector(".animate").classList.remove("animate-in");
};

//animating itmes on page load
setTimeout(function() {
    let animateItems = document.querySelectorAll(".animate");
    for (let index = 0; index < animateItems.length; index++) {
        animateItems[index].classList.add("animate-in");
    }
}, 100);


//FORM CHANGE EVENTS
let raq_form = document.getElementById('raq-form');
if(raq_form) {
    let raqForm = formChangeHandler(raq_form);
}

//favorites functionality
let Favorites = new init_favorites();
Favorites.init();

//WINDOW SCROLL
window.onscroll = function() {
    windowScroll();
};

window.onload = function() {
    windowScroll();
};

var header = document.querySelector('header');
if( document.querySelector('.sticky-side') ) {
    // let windowHeight = window.innerHeight;
    // let windowHeightFifty = windowHeight/2;
    var controller = new ScrollMagic.Controller();
    let anchors = document.querySelectorAll('.page-anchor');
    for(let index = 0; index < anchors.length; index++) {
        //console.log("#cat-"+anchors[index].id, anchors[index].parentElement.offsetHeight );
        new ScrollMagic.Scene({triggerElement: '#'+anchors[index].id})
            .setClassToggle(".cat-"+anchors[index].id, "active") // add class toggle
            //.addIndicators() // add indicators (requires plugin)
            .duration( anchors[index].parentElement.offsetHeight  )
            .addTo(controller);
    }


}

function windowScroll(){
    //
    let bodyScrollTop = document.body.scrollTop;
    let documentElementScrollTop = document.documentElement.scrollTop;
    if (bodyScrollTop > 5 || documentElementScrollTop > 5) {
        header.classList.add('is-sticky');
    } else {
        header.classList.remove('is-sticky');
    }
}

new Slinky( document.getElementById('mobile-menu'), { title: true });


//MATERIALS
let viewButtons = document.querySelectorAll('.view-material');
//console.log(favoriteButtons);
for (let index = 0; index < viewButtons.length; index++) {
    viewButtons[index].addEventListener('click', function(){
        showMaterial(viewButtons[index]);
    }, true);
}

function showMaterial(el) {

    let modal = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ['overlay', 'escape'],
        closeLabel: "Close",
        cssClass: ['material-modal', 'custom-class-2'],
        onOpen: function() {
            // console.log('modal open');
        },
        onClose: function() {
            // console.log('modal closed');
        },
        beforeClose: function() {
            // here's goes some logic
            // e.g. save content before closing the modal
            return true; // close the modal
            return false; // nothing happens
        }
    });

    const closeBtn = (`<div id="modal-close"><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" class="svg-inline--fa fa-times fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg></div>`);

    const content = (`${closeBtn}
        <div class="flex justify-center mb-4">
            <div class="material-title">${el.dataset.fabric}</div>
            <div class="material-sport">${el.dataset.sport}</div>
        </div>
        <div class="material-image"><img src="${el.dataset.src}"></div>
    `);

    modal.setContent(content);

    modal.open();

    document.getElementById('modal-close').addEventListener('click', function(){
        modal.close();
    }, true);

}

let viewApparel = document.querySelectorAll('.view-large');
//console.log(favoriteButtons);
for (let index = 0; index < viewApparel.length; index++) {
    viewApparel[index].addEventListener('click', function(){
        showApparel( getParentsUntil(viewApparel[index], '.apparel-category-items', '.apparel-item')[0] );
    }, true);
}

function showApparel(el) {

    let modal = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ['overlay', 'escape'],
        closeLabel: "Close",
        cssClass: ['apparel-modal', 'custom-class-2'],
        onOpen: function() {
            //console.log('modal open');
        },
        onClose: function() {
            //console.log('modal closed');
        },
        beforeClose: function() {
            // here's goes some logic
            // e.g. save content before closing the modal
            return true; // close the modal
            return false; // nothing happens
        }
    });

    const closeBtn = (`<div id="modal-close" class="apparel-item-close"><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" class="svg-inline--fa fa-times fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg></div>`);

    let fullres = el.dataset.fullres;
    fullres = fullres.split(',');
    let thumbs = el.dataset.thumbs;
    thumbs = thumbs.split(',');
    let thumbHtml = '';
    if(thumbs.length > 1) {
        thumbs.map((value, index) => {
            //console.log(value);
            thumbHtml = thumbHtml.concat('<div class="gallery-item" data-full="'+ fullres[index] +'"><img src="'+ value +'" alt=""></div>');
        });
    }


    const content = (`
        <div class="flex flex-wrap lg:flex-no-wrap relative modal-${el.dataset.id}">
            ${closeBtn}
            <div class="modal-images">
                <div class="modal-primary-image relative">
                    <div class="absolute inset-0 modal-primary-image-container">
                        <img src="${el.dataset.primaryimage}" class="object-contain w-full h-full" alt="">
                    </div>
                </div>
                <div class="gallery flex flex-wrap">
                    ${thumbHtml}
                </div>
            </div>
            <div class="modal-details w-full pt-10 md:w-1/2 xxl:w-2/5 md:pl-10 md:pt-10 product"
                data-id="${el.dataset.id}"
                data-primaryimage="${el.dataset.primaryimage}"
                data-thumbs="${el.dataset.thumbs}"
                data-fullres="${el.dataset.fullres}"
                data-sport="${el.dataset.sport}"
                data-style="${el.dataset.style}"
                data-category="${el.dataset.category}"
                data-title="${el.dataset.title}"
                >
                <div class="product-name font-teko text-3xl leading-none font-light">${el.dataset.title}</div>
                <div class="product-description">
                    ${el.dataset.description}
                </div>
                <div class="mt-4 apparel-favorite favorite-btn fb-${el.dataset.id}">
                    <span class="false">
                        <span class="xs:hidden xl:inline xxl:hidden">Favorite</span><span class="hidden xs:inline xl:hidden xxl:inline">Add to Favorites</span>
                    </span>
                    <span class="true">Remove</span>
                </div>
                <div>
                    <div class="mt-10 font-teko text-lg uppercase hide-when-no-favorites">Your Favorites</div>
                    <div class="favorite-list"></div>
                    <a href="/request-a-quote" class="mt-6 hidden md:inline-block mt-2 plain-button solid-red">
                        View Quote Request
                    </a>
                </div>
            </div>
        </div>
    `);

    modal.setContent(content);

    modal.open();

    //initialize gallery thumbs
    let modalDom = document.querySelector(`.modal-${el.dataset.id}`);
    //console.log(modalDom);

    //set active state on first item
    if(modalDom.querySelector('.gallery-item')) {
        modalDom.querySelector('.gallery-item').classList.add('active');
    }
    let domThumbs = modalDom.querySelectorAll('.gallery-item');
    for (let index = 0; index < domThumbs.length; index++) {
        domThumbs[index].addEventListener('click', function(event){
            modalDom.querySelector('.modal-primary-image-container').innerHTML = '';
            modalDom.querySelector('.modal-primary-image-container').insertAdjacentHTML('beforeend', `<img src="${domThumbs[index].dataset.full}" class="object-contain w-full h-full">`);
            [].forEach.call(domThumbs, function(el) {
                el.classList.remove("active");
            });
            domThumbs[index].classList.add('active');
        }, true);
    }

    //reinitialize favorites buttons
    Favorites.reset();

    modalDom.querySelector('.apparel-item-close').addEventListener('click', function(){
        modal.close();
        modal.destroy();
        Favorites.reset();
    }, true);

}


if(document.querySelector('.proof-grid')) {

    var infScroll = new InfiniteScroll( '.proof-grid', {
        // defaults listed

        // path: undefined,
        // REQUIRED. Determines the URL for the next page
        // Set to selector string to use the href of the next page's link
        path: '.pagination__next',
        // Or set with {{#}} in place of the page number in the url
        // path: '/blog/page/{{#}}'
        // or set with function
        // path: function() {
        //   return return '/articles/P' + ( ( this.loadCount + 1 ) * 10 );
        // }

        append: '.proof-item',
        // REQUIRED for appending content
        // Appends selected elements from loaded page to the container

        checkLastPage: true,
        // Checks if page has path selector element
        // Set to string if path is not set as selector string:
        //   checkLastPage: '.pagination__next'

        prefill: false,
        // Loads and appends pages on intialization until scroll requirement is met.

        responseType: 'document',
        // Sets the type of response returned by the page request.
        // Set to 'text' to return flat text for loading JSON.

        outlayer: false,
        // Integrates Masonry, Isotope or Packery
        // Appended items will be added to the layout

        scrollThreshold: 400,
        // Sets the distance between the viewport to scroll area
        // for scrollThreshold event to be triggered.

        elementScroll: false,
        // Sets scroller to an element for overflow element scrolling

        loadOnScroll: true,
        // Loads next page when scroll crosses over scrollThreshold

        history: 'replace',
        // Changes the browser history and URL.
        // Set to 'push' to use history.pushState()
        //    to create new history entries for each page change.

        historyTitle: true,
        // Updates the window title. Requires history enabled.

        hideNav: undefined,
        // Hides navigation element

        status: undefined,
        // Displays status elements indicating state of page loading:
        // .infinite-scroll-request, .infinite-scroll-load, .infinite-scroll-error
        // status: '.page-load-status'

        button: undefined,
        // Enables a button to load pages on click
        // button: '.load-next-button'

        onInit: undefined,
        // called on initialization
        // useful for binding events on init
        // onInit: function() {
        //   this.on( 'append', function() {...})
        // }

        debug: false,
        // Logs events and state changes to the console.
    });
}

let filters = document.querySelectorAll('.filter-select select');
if( filters ) {
    for(let index = 0; index < filters.length; index++) {
        filters[index].addEventListener('change', function(){
            updateFilters( filters[index].options[filters[index].selectedIndex].value );
        }, true);
    }
}

function updateFilters(setting) {
    // console.log(setting);
    for(let index = 0; index < filters.length; index++) {
        filters[index].value =  setting;
    }
    let items = document.querySelectorAll('.filter .product');
    if(setting == '') {
        for(let index = 0; index < items.length; index++) {
            items[index].classList.remove('hidden');
        }
    } else {
        for(let index = 0; index < items.length; index++) {
            if(items[index].dataset.style == setting) {
                items[index].classList.remove('hidden');
            } else {
                items[index].classList.add('hidden');
            }
        }
    }
}

window.updateFilters = updateFilters;

let searchOverlay = document.querySelector('.search-overlay');
let searchButton = document.querySelector('.search-btn');
if(searchButton && searchOverlay) {
    searchButton.addEventListener('click', function(){
        if(this.classList.contains('search-open')) {
            //close it
            this.classList.remove('search-open');
            searchOverlay.classList.remove('opacity-100');
            setTimeout(() => {
                searchOverlay.classList.remove('visible', 'flex');
            }, 300);
            document.querySelector('body').classList.remove('search-enabled');

        } else {
            //open it
            this.classList.add('search-open');
            searchOverlay.classList.add('opacity-100', 'visible', 'flex');
            document.querySelector('body').classList.add('search-enabled');
            // let bodyScrollTop = document.body.scrollTop;
            // document.querySelector('body').style.top = '-'+bodyScrollTop+'px';
        }
    }, true);
}

let orderData = document.querySelector('.order-data');
let formSubmitting = false;
if( orderData ) {
    let orderId = orderData.dataset.id;
    let amount = orderData.dataset.amount;
    axios.get(API_URL + `pay-order-form/${orderId}/${amount}`)
        .then(function (response) {
            // console.log(response.data, response.data.proceed);
            if(response.data.proceed) {
                document.querySelector('.order-amount').innerHTML = `$${response.data.amount}`;
                document.querySelector('.order-amount-input').value = response.data.amount;
                document.querySelector('.page-text').style.display = 'none';
                document.querySelector('.order-form-container').style.display = 'block';
            } else {
                document.querySelector('h1').innerHTML = response.data.msg.title;
                document.querySelector('.page-text .text-center').insertAdjacentHTML('beforeEnd', `<p>${response.data.msg.content}</p>`);
            }
        })
        .catch(function (error) {
            // handle error
            // console.log('error', error);
            document.querySelector('h1').innerHTML = 'An error has occured!';
            document.querySelector('.page-text .text-center').insertAdjacentHTML('beforeEnd', '<p>Please try refreshing the page. If the issue persists, please contact your TAS.</p>');
        })
        .finally(function () {
            // always executed
        });

    //set up cc fields
    new Cleave('.cc-num', {
        creditCard: true,
    });
    new Cleave('.cc-cvc', {
        blocks: [4],
        numericOnly: true
    });
    new Cleave('.cc-exp', {
        date: true,
        datePattern: ['m', 'Y']
    });

    document.getElementById('payment-form-25').addEventListener('submit', function(event) {
        event.preventDefault();
        if(formSubmitting == false) {
            let form = document.getElementById('payment-form-25');
            let formData = new FormData(form);
            formSubmitting = true;
            document.querySelector('.two-five-payment-button').innerHTML = 'Processing...';
            axios({
                    method: 'POST',
                    url: API_URL + `pay-order-form-do/${orderId}`,
                    data: formData
                })
                .then(function (response) {
                    if(response.data.proceed) {
                        window.location.href = "/payment-thank-you";
                    } else {
                        alert(response.data.msg);
                        if(response.data.input) {
                            document.querySelector("input[name*='"+response.data.input+"']").focus();
                        }
                        formSubmitting = false;
                        document.querySelector('.two-five-payment-button').innerHTML = 'Submit Payment';
                    }
                })
                .catch(function (error) {
                    // handle error
                    alert('An error has occurred. Please try again or contact your TWO FIVE Team Apparel Specialist.');
                    formSubmitting = false;
                    document.querySelector('.two-five-payment-button').innerHTML = 'Submit Payment';
                })
                .finally(function () {
                    // always executed
                });
        }


    }, true);
}

let raqForm = document.querySelector('#raq-form');
if(raqForm) {
    raqForm.addEventListener('submit', function(event) {
        event.preventDefault();
        if(formSubmitting == false) {
            let formData = new FormData(raqForm);
            formSubmitting = true;
            document.querySelector('.submit-quote-button').innerHTML = 'Processing...';
            axios({
                    method: 'POST',
                    url: API_URL + `submit-order`,
                    data: formData
                })
                .then(function (response) {
                    if(response.data.proceed) {
                        // store.delete('favorites');
                        window.location.href = "/order-subscribe-thank-you/";
                    } else {
                        alert('Something went wrong and we couldn\'t record your request. Please try again or give us a call.');
                        formSubmitting = false;
                        document.querySelector('.submit-quote-button').innerHTML = 'Submit For Quote';
                    }
                })
                .catch(function (error) {
                    // handle error
                    alert('Something went wrong and we couldn\'t record your request. Please try again or give us a call.');
                    formSubmitting = false;
                    document.querySelector('.submit-quote-button').innerHTML = 'Submit For Quote';
                })
                .finally(function () {
                    // always executed
                });
        }


    }, true);
}

let referralForm = document.querySelector('#referral-form');
if(referralForm) {
    referralForm.addEventListener('submit', function(event) {
        event.preventDefault();
        if(formSubmitting == false) {
            let formData = new FormData(referralForm);
            formSubmitting = true;
            document.querySelector('.submit-quote-button').innerHTML = 'Processing...';
            axios({
                    method: 'POST',
                    url: API_URL + `submit-order`,
                    data: formData
                })
                .then(function (response) {
                    if(response.data.proceed) {
                        // store.delete('favorites');
                        window.location.href = "/referral-thank-you/";
                    } else {
                        alert('Something went wrong and we couldn\'t record your request. Please try again or give us a call.');
                        formSubmitting = false;
                        document.querySelector('.submit-quote-button').innerHTML = 'Submit For Quote';
                    }
                })
                .catch(function (error) {
                    // handle error
                    alert('Something went wrong and we couldn\'t record your request. Please try again or give us a call.');
                    formSubmitting = false;
                    document.querySelector('.submit-quote-button').innerHTML = 'Submit For Quote';
                })
                .finally(function () {
                    // always executed
                });
        }
    }, true);
}

let sportSelector = document.querySelector('.sport-selector');
if(sportSelector) {
    let windowHeight = window.innerHeight;
    let headerHeight = document.querySelector('header').offsetHeight;
    let sportSelectorHeight = sportSelector.offsetHeight;
    // console.log(windowHeight, headerHeight, sportSelectorHeight);
    //const TOLERANCE = 0.1;
    if( (headerHeight + sportSelectorHeight) <  windowHeight &&  (headerHeight + sportSelectorHeight) > (windowHeight - 100) ) {
        sportSelector.classList.add('flex-it');
        //sportSelector.style.height = (windowHeight - headerHeight) + 'px';
        document.querySelector('.sport-content').style.height = (windowHeight - headerHeight) + 'px';
    }
}